module.exports = __webpack_public_path__ + "static/img/c4.fa09fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insidecamp/c4.jpg
// module id = Di4f
// module chunks = 0